'use memo';

import { createFileRoute } from '@tanstack/react-router';
import { GroupNamePage } from '../-components/GroupNamePage';
export const Route = createFileRoute('/_staff/labor-core/_egov-mock/egov-offboarding/group-name/')({
  component: GroupNamePage
});